import { render, staticRenderFns } from "./send-info.vue?vue&type=template&id=d5d1ee8a&scoped=true"
import script from "./send-info.vue?vue&type=script&lang=js"
export * from "./send-info.vue?vue&type=script&lang=js"
import style0 from "./send-info.vue?vue&type=style&index=0&id=d5d1ee8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d1ee8a",
  null
  
)

export default component.exports